
import { defineComponent } from '@nuxtjs/composition-api'
import Paragraph from '~/components/html/Paragraph.vue'

export default defineComponent({
  components: { Paragraph },
  props: ['title', 'text'],
  setup() {
    return {}
  },
})
